<template>
  <ul class="followers">
    <li>
      <person-name v-for="follower in ids" :key="follower" tag="li" :sid="follower" />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Prop } from 'vue/types/options'
import PersonName from './PersonName.vue'

export default defineComponent({
  name: 'JobFollowers',

  components: {
    PersonName,
  },

  props: {
    ids: {
      type: Array as Prop<string[]>,
      default: () => [],
    },
  },
})
</script>

<style scoped>
.followers {
  display: inline;
  list-style: none;
  padding: 0;
}

.followers li,
.followers li > p {
  display: inline;
}

.followers li:not(:last-of-type):after {
  content: ', ';
}
</style>
